import { render, staticRenderFns } from "./ProjectImage.vue?vue&type=template&id=0db83a30&scoped=true"
import script from "./ProjectImage.vue?vue&type=script&lang=js"
export * from "./ProjectImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db83a30",
  null
  
)

export default component.exports